import ExternalLinksBaseHandler from '../external_links_base_handler';
import * as EXTERNAL_LINKS_CONSTS from '../../external_links_consts';
import {OMG_POST_ACTIONS} from './external_links_omg_handler_consts';
import Device from '../../../../utils/device/device';
import ServiceFactory from '../../../../services/service_factory';
import {PRODUCT_PACKAGE_MAP} from '../external_links_base_handler_consts';
import {CHANNEL_SOURCE} from "../../../../../../common/const/casinofied-analytics-consts";
import {AreaType} from "@sparkware/uc-sdk-core/lib/apps/app-enums";

class ExternalLinksOMGHandler extends ExternalLinksBaseHandler {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'ExternalLinksOMGHandler';
    static HandlerName = 'omg';

    /**
     * decide if iframe needs to be displayed
     *
     */
    display() {}


    getAcceptedSourcesMap() {
        return [
            PRODUCT_PACKAGE_MAP.OMG_PP_ID
        ];
    }


    /**
     * Overrides base class executePostMessageAction
     * @param postMessageData
     * @returns {handleResult}
     */
    executePostMessageAction(postMessageData) {
        const actionId = postMessageData.ActionId.toString();
        this._sendAnalytic(actionId);
        switch (actionId) {
            case OMG_POST_ACTIONS.SHOW_ME:
                let dimensions = {width: postMessageData.Width, height: postMessageData.Height};
                if (Device.isMobile()) {
                    this.componentControllerRef.addAttrToIframe('scrolling', 'no');
                }
                // clearTimeout(this._showMeTimer);
                // this.componentControllerRef.openAwaitOverlay();
                this.componentControllerRef.setSize(dimensions).display();
                break;
            case OMG_POST_ACTIONS.MY_ACCOUNT:
                this.close();
                this.openExternalLink({
                    source: EXTERNAL_LINKS_CONSTS.GNWP_SOURCES.MY_ACCOUNT,
                    options: Object.assign(postMessageData.TabId ? {tabId: postMessageData.TabId} : {})
                });
                break;
            case OMG_POST_ACTIONS.CASHIER:
                this.close();
                this.openCashier(postMessageData, {
                    source: CHANNEL_SOURCE.omg,
                    area: AreaType.OMG,
                    element: OMG_POST_ACTIONS.CASHIER
                });
                break;
            case OMG_POST_ACTIONS.QUICK_DEPOSIT:
                this.close();
                const options = postMessageData.PromCode ? {PromCode: postMessageData.PromCode} : {};
                this._serviceFactory.cashierProxyService().openDeposit({
                    ...options,
                    channel: {
                        source: CHANNEL_SOURCE.omg,
                        area: AreaType.OMG,
                        element: OMG_POST_ACTIONS.QUICK_DEPOSIT
                    }
                });
                break;
            case OMG_POST_ACTIONS.OPEN_REAL_GAME:
                this.close();
                this.openRealGame(postMessageData.GameId);
                break;
            case OMG_POST_ACTIONS.OPEN_ANONYMOUS_GAME:
                this.close();
                this.openAnonymousGame(postMessageData.GameId);
                break;
            case OMG_POST_ACTIONS.SPORT:
                this.close();
                this.openExternalLink({
                    source: EXTERNAL_LINKS_CONSTS.GNWP_SOURCES.SPORT
                });
                break;
            case OMG_POST_ACTIONS.EXTERNAL_LINK:
                this.close();
                this.openExternalLink({
                    source: postMessageData.Url,
                    view: EXTERNAL_LINKS_CONSTS.NAVIGATION_VIEWS.IFRAME
                });
                break;

            case OMG_POST_ACTIONS.INTERNAL_URL:
                this.close();
                this._openInternalLink(postMessageData);
                break;
            case OMG_POST_ACTIONS.CLOSE_ME:
                this.componentControllerRef.closeLink();
                break;
            case OMG_POST_ACTIONS.RICH:
                this.close();
                let richPageUrl = ServiceFactory.create().integrationService().getRichPageUrl(postMessageData.campaignID);
                this._serviceFactory.windowService().redirect(richPageUrl);
                break;
            default:
                this.logger.warn('Not supported ActionID. ActionID = ' + postMessageData.ActionId);
                break;
        }
    }


    /**
     * Open Internal Link url over the same page
     * @private
     */
    _openInternalLink(postData) {
        if (postData && postData.Url) {
            let internalLink =  postData.Url;
            if(Device.hybrid.isEmbedded){
                //when it is internal link we need to redirect to the Hybrid localhost and not to the full url
                internalLink = this._serviceFactory.hybridService().getRedirectInternalPageUrl(postData.Url);
            }

            this._serviceFactory.windowService().redirect(internalLink);
        }
    }


    /**
     * Open real game by gameType.
     * Function extracts game name automatically from game type mapper
     *
     * @param gameType
     * @private
     */
    _openGame(gameType, isReal) {
        this.componentControllerRef.closeLink();
        if(isReal) {
            return super.openRealGame(gameType);
        } else {
            return super.openAnonymousGame(gameType);
        }

    }


    getHandlerName() {
        return ExternalLinksOMGHandler.HandlerName;
    }


    /**
     * Prepare and send analytics
     * @param analyticObject
     * @private
     */
    _sendAnalytic(actionId) {
        this.sendAnalytics({
            category: 'Client_OMG',
            action: Object.keys(OMG_POST_ACTIONS).find(k => OMG_POST_ACTIONS[k] === actionId)
        });
    }
}

export default ExternalLinksOMGHandler;